import { Component, Input } from '@angular/core';

@Component({
  selector: 'nested-table',
  templateUrl: './nested-table.component.html',
  styleUrls: ['./nested-table.component.css']
})
export class NestedTableComponent {
  @Input() data: any[] = [];

  dataSource: any[] = [];
  classificacao: any = {
    showCities: false
  }
  valorTotal: number
  qtdTotal: number
  cidade: any = {
    showCities: false
  }

  ngOnInit() {
    // Inicializa os dados adicionando as propriedades `showCities` e `showClients`
    this.dataSource = this.data.map(classificacao => ({
      ...classificacao,
      showCities: false,
      cidades: classificacao.cidades.map(cidade => ({
        ...cidade,
        showClients: false
      }))
    }));
    this.valorTotal = this.data.reduce((sum, item) => sum + item.valor, 0);
    this.qtdTotal = this.data.reduce((sum, item) => sum + item.quantidade, 0);
  }

  sumTotal(arr){
    return arr.reduce((sum, item) => sum + item.valor, 0);
  }


  toggleCities(classificacao: any) {
    classificacao.showCities = !classificacao.showCities;
  }

  toggleClients(cidade: any) {
    cidade.showClients = !cidade.showClients;
  }
}
